import useRequest from "@/composables/useRequest";
import { inject } from "vue";
export function http() {
    return inject("http");
}
export default http;
